import type { Dispatch, SetStateAction } from 'react'
import type { z } from 'zod'

import type { getRental_rental } from 'Constants/graphql/queries/detail/__generated__/getRental'

import type { reassignDeviceModalFormSchema } from './ReassignDeviceModal.schema'

export interface ReassignDeviceModalProps {
  handleSubmit: () => void
  onClose: () => void
  rental: getRental_rental
}

export interface ReassignDeviceModalFormProps {
  rental: getRental_rental
  onClose: () => void
  onSubmit: () => void
  setEmployeeName: Dispatch<SetStateAction<string>>
}

export interface ReassignDeviceModalConfirmationProps {
  employeeName: string
  onClose: () => void
}

export enum ReassignDeviceModalStepsEnum {
  'FORM' = '1',
  'CONFIRMATION' = '2',
}

export interface ReassignDeviceModalStepsMap {
  [key: string]: {
    component: React.FunctionComponent<any>
    props: any
  }
}

export type ReassignDeviceModalFormSchema = z.infer<
  typeof reassignDeviceModalFormSchema
>
